/**
 * 获取用户订阅的合集列表。
 *
 * @returns 返回用户订阅的合集列表的 Promise。
 *
 * @remarks
 * 该函数发送请求以获取用户订阅的合集列表。不需要额外的参数，会使用当前用户的身份进行请求。
 * 请注意，如果发生请求失败，错误将不会在此处捕获，而是被传递给调用方处理。
 *
 * @example
 * ```typescript
 * const subscribedCollections = await fetchSubsCollectionList();
 * console.log(subscribedCollections); // 返回用户订阅的合集列表
 * ```
 */
export async function fetchSubsCollectionList(): Promise<FavoriteFolder[]> {
  return http
    .get<{
      list: FavoriteFolder[]
    }>('/v1/favorite/get_subscription_list')
    .then((res) => res.data.list)
    .catch(() => [])
}
